import API from "@/service/Index";

import { Action, Module, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class PrivateFile extends VuexModule {
  @Action
  public DoGetPrivateFile(_input: any) {
    API.PrivateFileService.DoGenerateSASToken(_input).then((res) => {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      if (res.length > 0) {
        const privateFile = res[0];
        const privateFileUrl =
          process.env.VUE_APP_PeakBlobStorage?.toString().UrlCombine(
            `peakengine-paymentfile/${privateFile.blobPath}?${privateFile.blobSASToken}`
          ) ?? "";
        window.open(privateFileUrl, "_private_file");
      }
      this.context.dispatch("Loading/IsLoading", false, { root: true });
    });
  }
}
